import { render, staticRenderFns } from "./sellerList.vue?vue&type=template&id=485b8995&scoped=true&"
import script from "./sellerList.vue?vue&type=script&lang=js&"
export * from "./sellerList.vue?vue&type=script&lang=js&"
import style0 from "./sellerList.vue?vue&type=style&index=0&id=485b8995&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485b8995",
  null
  
)

export default component.exports